export default __webpack_public_path__ + "static/media/1.5fd176a1.jpg";